import isAlphanumeric from 'validator/lib/isAlphanumeric'
import isEmail from 'validator/lib/isEmail'
import i18n from '@plugins/localisation.js'
import { isObj } from '@helpers/utils.js'
import isURL from 'validator/lib/isURL'

// Each validation rule will accept input and optional error message
export const required = ({ input, error } = {}) => {
  if (isObj(input) && input.file === null) {
    return error ? error : i18n.global.t('validation_required')
  }

  return input === 1 ||
    input === '1' ||
    input === 0 ||
    input === '0' ||
    (input && input.length > 0) ||
    isObj(input) ||
    input
    ? true
    : error
    ? error
    : i18n.global.t('validation_required')
}

export const requiredNotZero = ({ input, error } = {}) => {
  return (input === 1 ||
    input === '1' ||
    (input && input.length > 0) ||
    isObj(input) ||
    input) &&
    input !== 0 &&
    input !== '0'
    ? true
    : error
    ? error
    : i18n.global.t('validation_required')
}

export const validateIf = (condition, validation, error) => {
  const fn = {
    temp: function ({ input }) {
      if (condition()) {
        return validation({ input, error })
      }
      return true
    },
  }['temp']

  fn.funcName = validation.name
  return fn
}

// used for required check checkboxes
export const checked = ({ input, error } = {}) => {
  return input === 1 || input === true
    ? true
    : error
    ? error
    : i18n.global.t('validation_checked')
}

export const email = ({ input, error } = {}) => {
  if (!input) {
    return true
  }
  return input && isEmail(input)
    ? true
    : error
    ? error
    : i18n.global.t('validation_email')
}

export const max = (number) => {
  return function max({ input, error }) {
    if (!input) return true
    return input && input.length <= number
      ? true
      : error
      ? error
      : i18n.global.t('validation_max', { max: number })
  }
}

export const url = ({ input, error } = {}) => {
  if (!input) return true

  return isURL(input) ? true : error ? error : i18n.global.t('validation_url')
}

export const size = (len) => {
  return ({ input, error } = {}) => {
    if (!input) return true
    return input && input.length === len
      ? true
      : error
      ? error
      : i18n.global.t('validation_size', { size: len })
  }
}

export const alphaNum = ({ input, error } = {}) => {
  if (!input) return true

  return input && isAlphanumeric(input)
    ? true
    : error
    ? error
    : i18n.global.t('validation_alpha_num')
}

export const regex = (reg, error) => {
  return function regex({ input } = {}) {
    if (!input) return true
    return reg.test(input) ? true : error
  }
}
